<template>
  <div class="custom-not-found">
    <div class="inner">
      <h1>Not Found</h1>
      Oops! Something went wrong. Please try again later.
    </div>
  </div>
</template>

<script>
export default {
  name: 'CustomNotFound',
  props: {
    data: Object
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/scss/_variables.scss';

.custom-not-found {
  padding: 3rem 0;
  text-align: center;
  .inner {
    display: inline-block;
    text-align: left;
    color: $gray;
  }
}
</style>
